import { getProductCondition } from "@/lib/productCondition";

export function ConditionBadge({ value }: { value: number }) {
  const c = getProductCondition(value);
  if (!c) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 text-[11px] font-medium rounded-full bg-neutral-100 text-neutral-600">
        ?
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1 max-w-full px-2 py-0.5 text-[10px] font-medium rounded-full ${c.badgeClassName}`}
      title={c.description}
    >
      <span className="tabular-nums font-semibold shrink-0">{c.value}</span>
      <span className="opacity-60">·</span>
      <span className="truncate">{c.shortName}</span>
    </span>
  );
}
